import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit'

import medecinModel, { Medecin, MedecinState } from '@/core/models/medecin.model'
import { CreateStaffDto, Staff } from '@/core/models/staff.model'
import { SearchRequestOptions } from '@/core/types/request'

import { RootState } from '@/redux/rootReducer'

export type MedecinReducerState = MedecinState

export const medecinAdapter = createEntityAdapter({ selectId: (medecin: Medecin) => medecin.cps })

const medecinsSelector = medecinAdapter.getSelectors((state: RootState) => state.medecin.medecins)

export const selectNewlyCreatedMedecinId = (state: RootState) => state.medecin.newlyCreatedItemId

export const selectMedecinSearchParams = (state: RootState) => state.medecin.search.params

export const selectMedecinSearchResults = (state: RootState) => state.medecin.search.result

export const selectMedecinListRequestTracker = (state: RootState) => state.medecin.requestTracker.list

export const selectMedecinCreateRequestTracker = (state: RootState) => state.medecin.requestTracker.create


export const selectMedecins = medecinsSelector.selectAll

const initialState: MedecinReducerState = {
  ...medecinModel.getInitialState()
}

const medecinSlice = createSlice({
  name: medecinModel.reducerName,
  initialState,
  reducers: {
    getMedecins: {
      reducer: (state, action: PayloadAction<{ query: Record<string, any>, options?: SearchRequestOptions }>) => {
        if (state.newlyCreatedItemId) state.newlyCreatedItemId = undefined
        state.search.params.query = action.payload.query
        state.search.params.options = action.payload.options
        state.requestTracker.list.loading = true
      },
      prepare: (query: Record<string, any>, options?: SearchRequestOptions) => ({
        payload: {
          query,
          options
        }
      })
    },
    getMedecinsSuccess(state, action: PayloadAction<{ items: Medecin[], totalCount: number }>) {
      const { items, totalCount } = action.payload
      medecinAdapter.setAll(state.medecins, items)
      state.search.result.totalCount = totalCount
      state.requestTracker.list.error = null
      state.requestTracker.list.loading = false
    },
    getMedecinsFailure(state, action) {
      state.requestTracker.list.error = action.payload
      state.requestTracker.list.loading = false
    },
    addMedecin(state, action: PayloadAction<CreateStaffDto>) {
      state.requestTracker.create.loading = true
    },
    addMedecinSuccess(state, action: PayloadAction<Staff>) {
      if (!!action.payload.cps) medecinAdapter.removeOne(state.medecins, action.payload.cps)
      state.newlyCreatedItemId = action.payload._id
      state.requestTracker.create.error = null
      state.requestTracker.create.loading = false
    },
    addMedecinFailure(state, action) {
      state.newlyCreatedItemId = undefined
      state.requestTracker.create.error = action.payload
      state.requestTracker.create.loading = false
    },
  }
})

export const {
  getMedecins,
  getMedecinsSuccess,
  getMedecinsFailure,
  addMedecin,
  addMedecinSuccess,
  addMedecinFailure
} = medecinSlice.actions

export default medecinSlice.reducer
